/**
 * Badge colorato per lo stato di pagamento di una fattura.
 *
 * Usa esclusivamente i token di @floraltech/ui per colori e stile.
 * Nessun colore hardcoded (DEC-015, regola 6.8 CLAUDE.md).
 */

import { Badge } from '@floraltech/ui';
import React from 'react';

/** Mappa stato pagamento -> variante badge. */
const STATO_VARIANTE: Record<string, 'default' | 'success' | 'warning' | 'destructive' | 'secondary'> = {
  // `non_pagata` e' NEUTRO, non allarmante: una fattura non ancora pagata e' la
  // condizione normale di 92 documenti su 105. Colorarla di rosso rendeva rossa
  // quasi ogni schermata, e un rosso sempre presente non segnala piu' niente.
  // Il rosso resta a `scaduta`, l'unico stato che richiede un'azione: prima i
  // due stati erano indistinguibili per colore.
  non_pagata: 'secondary',
  parzialmente_pagata: 'warning',
  pagata: 'success',
  scaduta: 'destructive',
};

/** Mappa stato pagamento -> etichetta leggibile in italiano. */
const STATO_LABEL: Record<string, string> = {
  non_pagata: 'Non pagata',
  parzialmente_pagata: 'Parziale',
  pagata: 'Pagata',
  scaduta: 'Scaduta',
};

interface StatoPagamentoBadgeProps {
  /** Stato del pagamento (es. 'pagata', 'non_pagata', 'scaduta'). */
  stato: string;
  /** Classe CSS aggiuntiva opzionale. */
  className?: string;
}

/**
 * Badge che mostra lo stato di pagamento con colore semantico.
 */
const StatoPagamentoBadge: React.FC<StatoPagamentoBadgeProps> = ({ stato, className }) => {
  const variante = STATO_VARIANTE[stato] ?? 'secondary';
  const label = STATO_LABEL[stato] ?? stato;

  return (
    <Badge variant={variante} className={className}>
      {label}
    </Badge>
  );
};

export default StatoPagamentoBadge;
